import { Dashboard } from '../../models';
import { idCreator } from '../../models/builder-utils';
import { RatesSharedSections } from './shared-rates.models';
import { TwoColumnDashboard } from './shared.models';

const idRoot = `tl-flatbed-rates`;

export const FlatbedNational: Dashboard = {
    id: idCreator(idRoot, ['dashboard']),
    sections: [...RatesSharedSections(idRoot, 'FLATBED')],
    classNames: {
        ...TwoColumnDashboard,
    },
};
